import _styled from "styled-components";
import React from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import { DROPZONE_SIZES, sizePropType } from '../consts';
const DefaultActiveDragContent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size,
    text
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    $_css: [size === DROPZONE_SIZES.SMALL ? theme.typography.heading3 : theme.typography.heading2]
  }, text || T.translate('DROP_FILES_TO_UPLOAD'));
});
DefaultActiveDragContent.displayName = 'DefaultActiveDragContent';
DefaultActiveDragContent.propTypes = {
  /** Dropzone size */
  size: sizePropType
};
export default DefaultActiveDragContent;
var _StyledDiv = _styled("div").withConfig({
  displayName: "DefaultActiveDragContent___StyledDiv",
  componentId: "sc-15zpb4n-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=DefaultActiveDragContent.js.map